<template>
    <div>
        <div class="carousel_wrapper hidden-xs-only">
            <el-carousel
                class="carousel_inner"
                :interval="2000"
                arrow="always"
                height="388px"
            >
                <el-carousel-item v-for="(item, idx) in imgList" :key="idx">
                    <img style="cursor: pointer;" @click="jumpDetail(item)" :src="item.imageUrl" alt="" />
                    <div
                        @click="jumpDetail(item)"
                        class="title_jump exceed_one_hidden"
                    >
                        {{ item.title }}
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <div class="carousel_wrapper_phone hidden-sm-and-up">
            <el-carousel
                class="elc_inner"
                :interval="2000"
                arrow="always"
                height="175px"
            >
                <el-carousel-item v-for="(item, idx) in imgList" :key="idx">
                    <img @click="jumpDetail(item)" :src="item.imageUrl" alt="" />
                    <div @click="jumpDetail(item)" class="titleJump exceed_one_hidden">{{ item.title }}</div>
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
import { bannerIe } from "../../../api/Home/home";
export default {
    mounted() {
        this.getBannerListRt();
    },
    data() {
        return {
            imgList: [],
        };
    },
    methods: {
        jumpDetail(item) {
            this.$router.push({
                path: "detail",
                query: {
                    titleName: this.$route.query.titleName,
                    detailObj: item,
                },
            });
        },
        // banner图
        async getBannerListRt() {
            let res = await bannerIe();
            this.imgList = res.data;
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/mixin.scss";
/* move */
.carousel_wrapper_phone {
    width: 100%;
    height: px2rem(175);
    margin-top: px2rem(56);
    img {
        width: 100%;
        height: px2rem(175);
    }
    .elc_inner {
        position: relative;
        width: 100%;
        height: 175px;
        .titleJump {
          width: px2rem(100);
          position: absolute;
          right: 0;
          bottom: px2rem(10);
          color: #fff;
          z-index: 999999999;
        }
    }
}
/* pc */
.carousel_wrapper {
    width: 100%;
    height: 388px;
    img {
        width: 100%;
        height: 388px;
    }
    .carousel_inner {
        position: relative;
        width: 100%;
        height: 388px;
        .title_jump {
            width: 300px;
            position: absolute;
            right: 20px;
            bottom: 15px;
            z-index: 999999999;
            font-size: 20px;
            color: #fff;
            cursor: pointer;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/components/Carousel.vue